module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_3016.7776ea30.png";